import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'starPrefix'
})
export class StarPrefixPipe implements PipeTransform {
  // Adds a "*" prefix to the input string
  transform(value: string): string {
    if (!value) return value;
    return `*${value}`;
  }
}
